import { render, staticRenderFns } from "./VanFieldMultipleSelection.vue?vue&type=template&id=1ab50191&scoped=true&"
import script from "./VanFieldMultipleSelection.vue?vue&type=script&lang=js&"
export * from "./VanFieldMultipleSelection.vue?vue&type=script&lang=js&"
import style0 from "./VanFieldMultipleSelection.vue?vue&type=style&index=0&id=1ab50191&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ab50191",
  null
  
)

export default component.exports